var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaction5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.916,
    height: 22.916,
    viewBox: "0 0 22.916 22.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    "data-name": "Group 1454",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 11.458,
    cy: 11.458,
    r: 11.458,
    transform: "translate(0 0)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1453",
    "data-name": "Group 1453",
    transform: "translate(6.386 7.272)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 1.085,
    cy: 1.927,
    rx: 1.085,
    ry: 1.927,
    transform: "translate(7.973)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 1.085,
    cy: 1.927,
    rx: 1.085,
    ry: 1.927,
    fill: "#242424"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M425.367,503.9a4.61,4.61,0,0,0-4.816-3.527,4.792,4.792,0,0,0-4.926,3.527h9.742Z",
    transform: "translate(-409.083 -485.233)",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction5);
export default __webpack_public_path__ + "static/media/reaction5.1e29cb9b8dfb58c36307a534b49272e8.svg";
export { ForwardRef as ReactComponent };